export class Router {
    private root = document.getElementById('app-root');
    private loader = document.getElementById('loading-overlay');

    constructor() {
        this.init();
    }

    private init() {
        // Interceptar clics en el Dock
        document.querySelectorAll('.dock-item').forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const route = (e.currentTarget as HTMLElement).dataset.route;
                if (route) this.navigate(route, true);
            });
        });

        // Manejar los botones de "Atr�s" y "Adelante" del navegador
        window.addEventListener('popstate', () => {
            const route = window.location.pathname.replace('/', '') || 'retail';
            this.navigate(route, false);
        });

        // Navegaci�n inicial (Eliminamos el hash y leemos la ruta real)
        const initialRoute = window.location.pathname.replace('/', '') || 'retail';
        this.navigate(initialRoute, false);
    }

    public async navigate(route: string, pushState: boolean = true) {
        if (!this.root || !this.loader) return;

        // 1. Mostrar Loader
        this.loader.classList.remove('hidden');

        try {
            // 2. Fetch de la vista
            const response = await fetch(`/views/${route}.html`);
            if (!response.ok) throw new Error('Vista no encontrada');
            const html = await response.text();

            // 3. Inyectar con delay
            setTimeout(() => {
                this.root!.innerHTML = `<section class="view-enter">${html}</section>`;
                this.loader!.classList.add('hidden');

                // Notificar a otros m�dulos (i18n, Analytics)
                window.dispatchEvent(new CustomEvent('viewInjected'));
                window.dispatchEvent(new CustomEvent('viewChanged', { detail: route }));

                // Actualizar interfaz del Dock
                this.updateDockUI(route);

                // API History: Cambia la URL en la barra superior SIN el #
                if (pushState) {
                    window.history.pushState({}, '', `/${route}`);
                }
            }, 300);

        } catch (err) {
            this.root.innerHTML = `<h1>Error 404</h1><p>No pudimos cargar la demo.</p>`;
            this.loader.classList.add('hidden');
        }
    }

    private updateDockUI(route: string) {
        document.querySelectorAll('.dock-item').forEach(btn => {
            btn.classList.toggle('active', (btn as HTMLElement).dataset.route === route);
        });
    }
}